import axios from 'axios';
import qs from 'qs';

class Api {
  constructor(api, isMultipart = false) {
    this.api = api;
    this.isMultipart = isMultipart;
    this.latestParams = null;

    this.get = this.get.bind(this);
    this.getLatest = this.getLatest.bind(this);
    this.getUrl = this.getUrl.bind(this);
    this.getById = this.getById.bind(this);
    this.save = this.save.bind(this);
    this.remove = this.remove.bind(this);
  }

  get(params) {
    this.latestParams = params;
    return axios.get(this.api, {
      params, paramsSerializer: p => qs.stringify(p),
    });
  }

  getLatest() {
    return this.get(this.latestParams);
  }

  getUrl(url, params) {
    return axios.get(this.api + url, {
      params, paramsSerializer: p => qs.stringify(p),
    });
  }

  getById(id, params) {
    return axios.get(`${this.api}/${id}`, {
      params, paramsSerializer: p => qs.stringify(p),
    });
  }

  save(data = {}, url) {
    const { id } = data;
    let options;

    if (this.isMultipart) {
      const formData = new FormData();

      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          // TODO: For images need to add prefix img or something else and check it. The same need on backend side.
          switch (key) {
            case 'logo': {
              const d = typeof data[key] === 'string'
                ? data[key]
                : {
                  uri: data[key].uri,
                  name: data[key].fileName || 'logo.jpg',
                  type: data[key].type,
                };
              formData.append(key, d);
              delete data[key];
              break;
            }
            case 'logos': {
              data[key].forEach((logo, i) => {
                const l = typeof logo === 'string'
                  ? logo
                  : {
                    uri: logo.uri,
                    name: logo.fileName || `logo${i}.jpg`,
                    type: logo.type,
                  };

                formData.append(`${key}${i}`, l);
              });

              delete data[key];
              break;
            }
            case 'license': {
              const d = typeof data[key] === 'string'
                ? data[key]
                : {
                  uri: data[key].uri,
                  name: data[key].fileName || 'license.jpg',
                  type: data[key].type,
                };
              formData.append(key, d);
              delete data[key];
              break;
            }
            case 'identification': {
              formData.append('identification_back', {
                uri: data[key].back.uri,
                name: data[key].back.fileName || 'back.jpg',
                type: data[key].back.type,
              });
              formData.append('identification_front', {
                uri: data[key].front.uri,
                name: data[key].front.fileName || 'front.jpg',
                type: data[key].front.type,
              });
              delete data[key];
              break;
            }
          }
        }
      }

      console.log('json', data);
      formData.append('json', JSON.stringify(data));

      data = formData;
      options = { headers: { 'Content-Type': 'multipart/form-data' } };
    }

    const api = url ? `${this.api}${url}` : this.api;

    return id
      ? axios.put(`${api}/${id}`, data, options)
      : axios.post(api, data, options);
  }

  remove(id) {
    return axios.delete(`${this.api}/${id}`);
  }
}

export default Api;



// WEBPACK FOOTER //
// ./src/services/providers/Common/Api.js